import type { V2AnnotationPayload } from '@/store/types'

export const hasAnnotationPropertiesData = (
  annotation: Pick<V2AnnotationPayload, 'properties'>,
): boolean =>
  !!annotation.properties &&
  Object.values(annotation.properties).some((prop) =>
    prop ? Object.values(prop).some((data) => !!data?.length) : false,
  )
